import datePicker from './datePicker';
import hidden from './hidden';
import input from './input';
import textarea from './textarea';
import slider from './slider';
import timePicker from './timePicker';
import row from './row';
import select from './select';

export default [
    datePicker,
    hidden,
    input,
    textarea,
    slider,
    timePicker,
    row,
    select
]
